import { expand } from 'uri-template-lite';
import { apiClient } from '../../common/ApiClient';
import { createApiQueryHook } from '../../common/queryClient/createApiQueryHook';
import { DataObjectGroupUrl } from './DataObjectGroupUrl';
import { DataObjectGroupExtendedDto } from '../schema/types';

export const getDataObjectGroupInfoQuery = async (id: number) =>
  apiClient
    .get<DataObjectGroupExtendedDto>(
      expand(DataObjectGroupUrl.EXTENDED, {
        id,
      })
    )
    .then((response) => response.data);

export const useDataObjectGroupInfoQuery = createApiQueryHook(
  ['dataObjectGroupInfo'],
  getDataObjectGroupInfoQuery
);
